export { default as Add } from './Add'
export { default as AlertTriangle } from './AlertTriangle'
export { default as Apply } from './Apply'
export { default as ArrowDown } from './ArrowDown'
export { default as ArrowLeft } from './ArrowLeft'
export { default as ArrowRight } from './ArrowRight'
export { default as Bookmark } from './Bookmark'
export { default as Calendar } from './Calendar'
export { default as Campus } from './Campus'
export { default as Check } from './Check'
export { default as Checkbox } from './Checkbox'
export { default as CheckCircle } from './CheckCircle'
export { default as ChevronDown } from './ChevronDown'
export { default as ChevronLeft } from './ChevronLeft'
export { default as ChevronRight } from './ChevronRight'
export { default as ChevronUp } from './ChevronUp'
export { default as Choose } from './Choose'
export { default as CircleDotsVertical } from './CircleDotsVertical'
export { default as Close } from './Close'
export { default as Compass } from './Compass'
export { default as Course } from './Course'
export { default as Delete } from './Delete'
export { default as Document } from './Document'
export { default as DotsHorizontal } from './DotsHorizontal'
export { default as DotsVertical } from './DotsVertical'
export { default as DownloadCall } from './DownloadCall'
export { default as EditPencil } from './EditPencil'
export { default as Education } from './Education'
export { default as ErrorOutline } from './ErrorOutline'
export { default as Eye } from './Eye'
export { default as EyeOff } from './EyeOff'
export { default as Facebook } from './Facebook'
export { default as FilePDF } from './FilePDF'
export { default as FooterFacebook } from './FooterFacebook'
export { default as FooterInstagram } from './FooterInstagram'
export { default as FooterLinkedIn } from './FooterLinkedin'
export { default as FooterTwitch } from './FooterTwitch'
export { default as FooterYouTube } from './FooterYouTube'
export { default as Google } from './Google'
export { default as HelpCircle } from './HelpCircle'
export { default as InfoCircle } from './InfoCircle'
export { default as InfoOutline } from './InfoOutline'
export { default as LinkedIn } from './LinkedIn'
export { default as Mail } from './Mail'
export { default as Notification } from './Notification'
export { default as Phone } from './Phone'
export { default as Pin } from './Pin'
export { default as Retake } from './Retake'
export { default as Search } from './Search'
export { default as Send } from './Send'
export { default as SendAlternative } from './SendAlternative'
export { default as Share } from './Share'
export { default as Spinner } from './Spinner'
export { default as Substract } from './Substract'
export { default as SuccessOutline } from './SuccessOutline'
export { default as Support } from './Support'
export { default as Telegram } from './Telegram'
export { default as TextFlow } from './TextFlow'
export { default as Trophy } from './Trophy'
export { default as Twitter } from './Twitter'
export { default as Upload } from './Upload'
export { default as UserCircle } from './UserCircle'
export { default as WarningCircle } from './WarningCircle'
export { default as WarningOutline } from './WarningOutline'
export { default as Whatsapp } from './Whatsapp'
